import React from 'react';
import { connect } from 'react-redux';
import { useUIDSeed } from 'react-uid';

import { SlideLeft } from '@prisjakt/ui/hideable/variants';
import SidebarMenu from './components/menu-bar';
import { useViewportContext } from '../../../../components/viewport/context';

import List from '../../views/list';
import Lists from '../../views/lists';
import Alerts from '../../views/alerts';
import SidebarFilter from '../../views/filter';

import { SIDEBAR_STATE } from '../../constants';
import { FILTER_PORTAL_ID } from '../../../product-collection/constants';

import { AppState } from '../../../../reducers';

import * as S from './styles';

import { SelectedList } from '../../types';

type OwnProps = {
  className?: string;
};

type StateProps = {
  tab:
    | SIDEBAR_STATE.NONE
    | SIDEBAR_STATE.LISTS
    | SIDEBAR_STATE.ALERTS
    | SIDEBAR_STATE.FILTER;
  selectedList?: SelectedList;
  showFilter: boolean;
  filterType: string;
};

type Props = OwnProps & StateProps;

const Sidebar = ({
  className,
  tab = SIDEBAR_STATE.NONE,
  selectedList,
  showFilter,
  filterType,
}: Props) => {
  const { isDesktop } = useViewportContext();
  const isSidebarOpen = tab !== SIDEBAR_STATE.NONE;

  // Generate unique UIDs to use as HTML ids
  const getId = useUIDSeed();
  const listsTabId = getId('sidebar-desktop-lists');
  const alertsTabId = getId('sidebar-desktop-alerts');
  const filterTabId = getId('sidebar-desktop-filter');

  const renderSidebarContent = () => {
    const content = (() => {
      switch (tab) {
        case SIDEBAR_STATE.LISTS:
          return selectedList ? (
            <List id={selectedList} draggable />
          ) : (
            <Lists draggable />
          );
        case SIDEBAR_STATE.ALERTS:
          return <Alerts />;
        case SIDEBAR_STATE.FILTER:
          if (!showFilter) {
            return null;
          }

          return filterType === 'category' ? (
            <SidebarFilter />
          ) : (
            <S.SidebarFilter id={FILTER_PORTAL_ID} />
          );
        default:
          return null;
      }
    })();

    const id = {
      [SIDEBAR_STATE.LISTS]: listsTabId,
      [SIDEBAR_STATE.ALERTS]: alertsTabId,
      [SIDEBAR_STATE.FILTER]: filterTabId,
    }[tab];

    return <S.SidebarContent id={id}>{content}</S.SidebarContent>;
  };

  return (
    <S.Sidebar tab={tab} className={className} data-test="SidebarDesktop">
      <S.Sticky>
        <SidebarMenu />

        {isDesktop && (
          <SlideLeft visible={isSidebarOpen}>
            {renderSidebarContent()}
          </SlideLeft>
        )}
      </S.Sticky>
    </S.Sidebar>
  );
};

Sidebar.displayName = 'Sidebar';

const mapStateToProps = (state: AppState) => ({
  tab: state.areas.sidebar.tab,
  selectedList: state.areas.sidebar.selectedList,
  filterType: state.areas.sidebar.filterType,
  showFilter:
    state.areas.category.filter.showFilter || state.areas.sidebar.hasFilter,
});

export default connect(mapStateToProps, {})(Sidebar);
